<template>
  <div class="mt-5">
    <vue-content-loading v-for="i in 5" :key="i" :width="1920" :height="400" class="mb-5">
      <rect x="0" y="0" rx="3" ry="3" width="48%" height="400" />
      <rect x="50%" y="0" rx="3" ry="3" width="48%" height="400" />
    </vue-content-loading>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading'

export default {
  name: 'topic-resume-loader',

  components: {
    VueContentLoading,
  },
}
</script>

<style scoped></style>
